<template>
  <v-container grid-list-md>
    <v-dialog v-model="dialog" persistent width="500px">
      <v-card>
        <v-card-text>
          <v-flex md8>
            <simple-date-input
              :upperLimmitOfYear="2100"
              v-model="selectedItem.give_date"
              v-if="dialog"
              label="付与日"
            />
          </v-flex>
          <v-flex md8>
            <simple-date-input
              :upperLimmitOfYear="2100"
              v-model="selectedItem.deadline"
              v-if="dialog"
              label="有効期限"
            />
          </v-flex>
          <v-flex md3>
            <v-text-field
              v-model.number="selectedItem.add_days"
              v-if="dialog"
              type="number"
              label="付与日数"
            />
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="createItem">追加</v-btn>
          <v-btn @click="dialog = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="historyDialog" width="500">
      <v-card>
        <v-card-text>
          <div class="tableTitle">取得履歴</div>
          <table v-show="history_rows.length > 0" class="history-table">
            <tr>
              <th>日時</th>
              <th>消化日数</th>
            </tr>
            <tr v-for="(item , i) in history_rows" :key="i">
              <td>{{item.date_id}}</td>
              <td>{{item.numberOfDays}}</td>
            </tr>
          </table>
          <p id="no-history-msg" v-show="history_rows.length == 0">履歴はありません。</p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="pageTitle">有給休暇</div>
    <v-layout row>
      <v-flex md9>
        <v-btn flat :to="{name:'home', params:{user_id:$route.params.user_id} }" color="primary">
          <v-icon>arrow_back_ios</v-icon>タイムシートに戻る
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex md1>
        <v-btn color="blue" class="white--text" @click="addItem">追加</v-btn>
      </v-flex>
    </v-layout>
    <v-data-table :headers="headers" :items="rows" hide-actions class="elevation-1">
      <template slot="items" slot-scope="props">
        <tr :class="{'invalid-row': !props.item.is_displayed}">
          <td class="text-xs-left">{{ props.item.deadline }}</td>
          <td class="text-xs-left">{{ props.item.days }}</td>
          <td class="text-xs-left">{{ props.item.add_days }}</td>
          <td>
            <v-btn icon @click="showHistory(props.item.index)">
              <v-icon>history</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-layout row>
      <v-flex md9>
        <v-btn flat :to="{name:'home', params:{user_id:$route.params.user_id} }" color="primary">
          <v-icon>arrow_back_ios</v-icon>タイムシートに戻る
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import db from "@/components/firebaseInit";
import firebase from "firebase";
import SimpleDateInput from "@/components/common/simpleDateInput";
import { mapMutations, mapGetters, mapActions } from "vuex";
import {
  unixtimeToJapaneseShortFormattedDate,
  getMoment
} from "@/utils/datetime.js";

const moment = getMoment();
const newItem = {
  add_days: 20,
  give_date: moment().unix(),
  deadline: moment()
    .add(2, "year")
    .unix(),
  monthly_historys: {}
};
export default {
  components: {
    SimpleDateInput
  },
  props: [],
  data() {
    return {
      item: {},
      items: [],
      rows: [],
      history_rows: [],
      selectedItem: {},
      paidDaysOffDbRef: db.collection("paid_days_off"),
      headers: [
        {
          text: "有効期限",
          align: "left",
          sortable: false,
          value: "deadline"
        },
        {
          text: "残日数",
          align: "left",
          sortable: false,
          value: "days"
        },
        {
          text: "追加日数",
          align: "left",
          sortable: false,
          value: "add_days"
        },
        { text: "操作", sortable: false }
      ],
      dialog: false,
      historyDialog: false,
      timecards: [],
      userId: null,
      monthId: ""
    };
  },
  computed: {
    title() {
      return "ユーザー情報" + (this.action == "add" ? " 新規追加" : " 更新");
    },
    ...mapGetters("auth", ["user"]),
    ...mapGetters("timesheet", ["paidDayOffItems"])
  },
  mounted() {
    this.monthId = moment().format("YYYY-MM");
    this.userId = this.$route.params.user_id;
    this.reload();
  },
  methods: {
    async reload() {
      try {
        this.changeLoadingState(true);
        await this.getPaidDayOffItems({
          ownerId: this.userId,
          monthId: this.monthId
        });
        this.items = this.paidDayOffItems.sort((a, b) => {
          return a.deadline - b.deadline;
        });
        this.rows = [];
        this.items.forEach((item, index) => {
          this.rows.push({
            deadline: unixtimeToJapaneseShortFormattedDate(item.deadline),
            days: item.days_left,
            add_days: item.add_days,
            index: index,
            is_displayed: item.isDisplayed,
            id: item.id
          });
        });
      } catch (e) {
        console.error(e);
      }
      this.changeLoadingState(false);
    },
    addItem() {
      this.selectedItem = JSON.parse(JSON.stringify(newItem));
      this.action = "add";
      this.dialog = true;
    },
    async deleteItem(id) {
      this.changeLoadingState(true);
      try {
        await this.paidDaysOffDbRef.doc(id).delete();
        this.changeLoadingState(false);
      } catch (e) {
        console.error(e);
        this.changeLoadingState(false);
      }
      this.reload();
    },
    async createItem() {
      this.changeLoadingState(true);
      this.$set(this.selectedItem, "owner_id", this.$route.params.user_id);

      try {
        await this.paidDaysOffDbRef.add(this.selectedItem);
        this.changeLoadingState(false);
        this.dialog = false;
      } catch (e) {
        console.error(e);
        this.changeLoadingState(false);
      }
      this.reload();
    },
    showHistory(index) {
      this.history_rows = this.items[index].historys;
      this.historyDialog = true;
    },
    ...mapActions("app", ["changeLoadingState"]),
    ...mapActions("timesheet", ["getPaidDayOffItems"])
  }
};
</script>

<style lang="scss" scoped>
div.pageTitle {
  font-size: 20px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
.subTitle {
  margin: 10px;
}
.tableTitle {
  font-size: 16px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
.tableTitle:before {
  content: "";
  background-color: #ff5722;
  display: inline-block;
  height: 15px;
  margin-right: 10px;
  position: relative;
  top: 2px;
  width: 15px;
}
table.history-table {
  margin: 10px;
  border: solid 1px;
  border-collapse: collapse;
  th {
    text-align: left;
  }
  th,
  td {
    border: solid 1px;
    padding: 5px 10px;
  }
  td {
    text-align: right;
  }
}

</style>


